module.exports = __webpack_public_path__ + "static/media/branco.01325235.svg";